import { useState } from "react";
import AcaoButtons from "../../Shared/AcaoButtons";
import CodigoLancamentoFortesCampo from "../../Shared/CodigoLancamentoFortesCampo";

/**
 * Etapa de lançamento (Confirmação de Lançamento da Despesa e Lançamento de Nota de Compras): além das
 * ações, o campo opcional "Código de Lançamento do Fortes". O código só vai junto da ação que conclui o
 * lançamento (`acaoConclusao`); retificar não mexe nele.
 */
export default function EtapaLancamentoFortes({ solicitacao, detalheProcesso, acoes = [], acaoEmExecucao, onExecutarAcao, texto, acaoConclusao }) {
    const [codigo, setCodigo] = useState(detalheProcesso?.codigoLancamentoFortes || "");

    function executar(acao) {
        if (acao === acaoConclusao) {
            onExecutarAcao(acao, { dados: { codigoLancamentoFortes: codigo.trim() } });
        } else {
            onExecutarAcao(acao);
        }
    }

    return (
        <div className="flex flex-col gap-4">
            {texto && <p className="text-sm text-muted-foreground">{texto}</p>}
            <CodigoLancamentoFortesCampo
                solicitacaoId={solicitacao?.id}
                valor={codigo}
                onChange={setCodigo}
                disabled={!!acaoEmExecucao}
            />
            <div className="flex justify-end">
                <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} />
            </div>
        </div>
    );
}
